module.exports = __webpack_public_path__ + "media/images/samples/infographics/article-img-ada74d4efdd593f69f1e93ffeedd7984.jpg";